import { render } from "./DownloadImagesComponent.vue?vue&type=template&id=764614ce&scoped=true"
import script from "./DownloadImagesComponent.vue?vue&type=script&lang=js"
export * from "./DownloadImagesComponent.vue?vue&type=script&lang=js"

import "./DownloadImagesComponent.vue?vue&type=style&index=0&id=764614ce&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen2/autoringen2.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764614ce"],['__file',"resources/themes/default/js/components/lots/DownloadImagesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "764614ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('764614ce', __exports__)) {
    console.log('reload')
    api.reload('764614ce', __exports__)
  }
  
  module.hot.accept("./DownloadImagesComponent.vue?vue&type=template&id=764614ce&scoped=true", () => {
    console.log('re-render')
    api.rerender('764614ce', render)
  })

}


export default __exports__